import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { Route } from "~services/router/Route";
import { valueOrFallback } from "~utils/sanitizeDto";

import { useSelector } from "../../hooks";

// Centralized strings for internationalization
const tReturnToRoom = "Return to the room";
const tReturnToHome = "Return to home";
const tPaymentProcessed = "Payment processed";
const tPaymentCancelled = "Payment cancelled";

/** @deprecated We are phasing out `components/**` */
const PaymentResult = ({ label }: { label: string }) => {
  const id = useSelector((state) => state.app.paymentRoomId);
  return (
    <>
      <Typography variant="h4">{label}</Typography>
      <br />
      {id ? (
        <Link
          to={Route.roomView({
            roomId: valueOrFallback(id, "MISSING_ID", "(PaymentResult) Missing state.app.paymentRoomId"),
          })}
        >
          <Button>{tReturnToRoom}</Button>
        </Link>
      ) : (
        <Link to={Route.home()}>
          <Button>{tReturnToHome}</Button>
        </Link>
      )}
    </>
  );
};

/** @deprecated We are phasing out `components/**` */
export const Success = () => <PaymentResult label={tPaymentProcessed} />;

/** @deprecated We are phasing out `components/**` */
export const Cancel = () => <PaymentResult label={tPaymentCancelled} />;
